import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

/* MATCH HEADER HEIGHT EXACTLY */
const HEADER_HEIGHT = 44;

const steps = [
  { label: "Delivery", route: "/delivery-location" },
  { label: "Summary", route: "/order-summary" },
  { label: "Payment", route: "/payment" },
  { label: "Success", route: "/order-success" },
];

const CheckoutBreadcrumbs = ({ active }) => {
  const navigate = useNavigate();

  const handleClick = (index) => {
  // 🚫 Disable breadcrumb navigation on Success page
  if (active === 3) return;

  if (index <= active) {
    navigate(steps[index].route);
  }
};


  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mt: `${HEADER_HEIGHT + 0}px`,
        mb: 3,
        px: { xs: 1.5, sm: 2 },
        py: 1.5,
        p: 2,
        bgcolor: "#fff",
        borderRadius: 3,
        boxShadow: 2,
         maxWidth: 700,
          mx: "auto",
          minHeight: 40, 
        overflowX: "auto",
      }}
    >
      {steps.map((step, i) => {
        const isCompleted = i < active;
        const isSuccessStep = step.label === "Success";
        const isSuccessDone = isSuccessStep && active === 3;
        const isActive = i === active && !isSuccessDone;

        // ✅ FINAL COLOR LOGIC
        const color =
          isCompleted || isSuccessDone
            ? "#2e7d32" // GREEN
            : isActive
            ? "#ff9900" // ORANGE
            : "#bdbdbd"; // GRAY

        return (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              minWidth: 90,
              cursor: i <= active ? "pointer" : "not-allowed",
            }}
            onClick={() => handleClick(i)}
          >
            {/* STEP CIRCLE */}
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                bgcolor: color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 14,
                fontWeight: 700,
               
              }}
            >
              {isCompleted || isSuccessDone ? (
                <CheckCircle sx={{ fontSize: 18 }} />
              ) : (
                i + 1
              )}
            </Box>

            {/* LABEL */}
            <Typography
              sx={{
                ml: 1,
                fontSize: 13,
                fontWeight: isActive ? 700 : 500,
                color,
                whiteSpace: "nowrap",
              }}
            >
              {step.label}
            </Typography>

            {/* CONNECTOR */}
            {i !== steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: 2,
                  mx: 1,
                  bgcolor: i < active ? "#2e7d32" : "#e0e0e0",
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default CheckoutBreadcrumbs;
